<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :label="$lang.rounded" v-model="rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" :label="$lang.flat" v-model="flat" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mx-1']" :items="ratios" v-model="ratio" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <flags :rounded="rounded" :flat="flat" :ratio="ratio[0]" :flags-dir="`${$root.config.staticAssetsDir}/flags`" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageFlag',
  data () {
    return {
      ratio: ['1:1'],
      flat: false,
      rounded: false,
      ratios: ['1:1', '4:3'].map(text => {
        return {
          text,
          value: text
        }
      })
    }
  },
  watch: {
    rounded () {
      if (this.rounded) {
        this.ratio = [this.ratios[0].value]
      }
    },
    ratio () {
      if (this.ratio[0] === this.ratios[1].value) {
        this.rounded = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/flag.vue